<template>
  <div>
    <div class="container">
      <!-- 头部操作 -->
      <!-- 占位 -->
      <div class="seat"></div>

      <!-- 表格区域 -->
      <div class="table_title">{{ tableName || "分配接入报表学员详情" }}</div>
      <StudentsTableHeader
        id="AssignAccessStudentList"
        :empty-text="emptyText"
        ref="AssignAccessStudentList"
        componentTableId="AssignAccessStudentList"
        :table-height="tableMaxHeight"
        :excelName="tableName || '分配接入报表学员详情'"
        :header-data="headerData"
        :element-loading-text="loadingText"
        @update-list="getData"
        :table-data="tableData"
        :table-loading="tableLoading"
        @search-data="tableSearch"
        @search-remote="searchRemote"
      >
        <template v-slot:studentNamecustom="scope">
          <!-- <template v-if="scope.scope.remarks && scope.scope.remarks.length > 0">
             <el-tooltip
               popper-class="mt35"
               effect="dark"
               content="点击查看备注信息列表"
               placement="bottom"
             >
               <el-tag @click="handleScopeCourse(scope.scope, 'remarks')" class="hand"
                 >备注{{ scope.scope.remarks.length }}</el-tag
               >
             </el-tooltip>
           </template>
           <template v-if="scope.scope.trackCount && scope.scope.trackCount > 0">
             <el-tooltip
               popper-class="mt35"
               effect="dark"
               content="点击查看跟踪信息列表"
               placement="bottom"
             >
               <el-tag @click="handleScopeTrack(scope.scope)" class="hand"
                 >跟踪{{ scope.scope.trackCount }}</el-tag
               >
             </el-tooltip>
           </template> -->
           <span
             class="blue hand"
             v-if="scope.scope.studentName"
             @click="openDialog(scope.scope)"
             >{{ scope.scope.studentName }}</span
           >
           <span v-else class="gray hand" @click="openDialog(scope.scope)">未设置</span>
         </template>

         <template v-slot:createTimecustom="scope">
           <span class="" v-if="scope.scope.createTime">{{ scope.scope.createTime }}</span>
           <span v-else class="gray">未设置</span>
         </template>

         <template v-slot:payCoursescustom="scope">
           <template v-if="scope.scope.payCourses && scope.scope.payCourses.length > 0">
             <el-tooltip popper-class="mt35" effect="dark" content="点击查看购买的课程列表" placement="bottom">
               <span class="hand" @click="handleScopeCourse(scope.scope, 'PayCourse')">
                 共购买
                 <span class="blue">
                   {{
                     scope.scope.payCourses.length
                   }}
                 </span>个课程
               </span>
             </el-tooltip>
           </template>
           <span v-else class="gray">还未购买课程</span>
         </template>
         <template v-slot:stateStrcustom="scope">
          <span>
            <studentStateTagColor
              v-bind:studentState="converInfo(scope.scope)"
            ></studentStateTagColor>
          </span>
        </template>
      </StudentsTableHeader>

      <!-- 底部工具 -->
      <pagination-tool
        :pagination="pagination"
        :is-loading="tableLoading"
        @change-pagination="changePagination"
      >
      </pagination-tool>

             <!--购买的课程弹框-->
       <el-dialog :title="CourseTitle" :visible.sync="dialogVisibleCourse" v-if="dialogVisibleCourse" width="1200px"
         v-dialogDrag top="15vh" :close-on-click-modal="false">
         <div class="dialog_div2">
           <el-table :data="payCourseList" style="width: 100%" border height="420px" stripe
             :header-cell-style="{ background: '#f5f7fa' }">
             <el-table-column width="430" prop="title" label="课程标题"></el-table-column>
             <el-table-column prop="payMoney" label="实付金额(元)" align="center">
               <template scope="scope">
                 <span v-if="scope.row.payMoney">{{ scope.row.payMoney }}元</span>
                 <span v-else>免费</span>
               </template>
             </el-table-column>
             <el-table-column prop="gradeName" label="所属班级" align="center" width="410">
               <template scope="scope">
                 <span v-if="scope.row.gradeName">{{ scope.row.gradeName }}</span>
                 <span v-else class="gray">未设置</span>
               </template>
             </el-table-column>
             <el-table-column prop="payTime" label="购买时间" width="180" align="center">
               <template scope="scope">
                 <span v-if="scope.row.payTime">{{ scope.row.payTime }}</span>
                 <span v-else class="gray">未设置</span>
               </template>
             </el-table-column>
           </el-table>
         </div>
       </el-dialog>

       <!--备注信息弹框-->
       <el-dialog
         :title="remarksTitle"
         :visible.sync="dialogVisibleRemarks"
         v-if="dialogVisibleRemarks"
         width="1000px"
         v-dialogDrag
         top="15vh"
         :close-on-click-modal="false"
       >
        <div class="dialog_div2">
          <el-table
            :data="remarksList"
            style="width: 100%"
            border
            height="420px"
            stripe
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column prop="createTime" label="日期" width="180" align="center">
              <template scope="scope">
                <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="adminName" label="操作人" width="180" align="left">
              <template scope="scope">
                <span v-if="scope.row.adminName">{{ scope.row.adminName }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="contents" label="备注内容" align="left">
              <template scope="scope">
                <span v-if="scope.row.contents">{{ scope.row.contents }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

             <!-- 学生详情弹框（新） -->
       <StudentDialog
         title="学生详情"
         :show.sync="dialogVisibleDetail"
         v-if="dialogVisibleDetail"
         @isfullscreen="isfullscreen"
         :isFooter="false"
       >
         <div class="abow_dialog3" slot="body">
           <StudentDetailNew
             :isService="true"
             v-if="dialogVisibleDetail"
             :studentId="studentId"
             :isFullscreen='isFullscreen'
             class="dialog_div_detail1"
           ></StudentDetailNew>
         </div>
       </StudentDialog>

       <!-- 跟踪记录弹窗 -->
       <el-dialog
         :title="TrackTitle"
         :visible.sync="dialogVisibleTrack"
         v-if="dialogVisibleTrack"
         width="45%"
         v-dialogDrag
         top="18vh"
         :close-on-click-modal="false"
         :before-close="closeDialog"
       >
        <div class="dialog_div1">
          <StudentTrackRecord
            v-if="dialogVisibleTrack"
            :studentId="studentId"
            class="abow_dialog"
            @close-dialog="closeDialog"
          ></StudentTrackRecord>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetReportStudentList,GetBusinessStudentsSelectListData } from "@/network/statistics.js";
import StudentsTableHeader from "components/StudentList";
import PaginationTool from "components/PaginationTool";
import { isNull } from "../../common/utils";
import { GetCatetListByType } from "network/studentSortModule";
import { getAdminList } from "network/administrator";
import StudentTrackRecord from "views/business/studentTrack/studentTrackRecord.vue";
import StudentDialog from "components/StudentDialog";
import StudentDetailNew from "../studentsV2/studentDetailNew.vue";
import studentStateTagColor from "components/studentStateTagColor";
export default {
  name: "AssignAccessStudentList",
     components: {
     StudentsTableHeader,
     PaginationTool,
     StudentTrackRecord,
     StudentDialog,
     StudentDetailNew,
     studentStateTagColor
   },
  data() {
    return {
      tableName: "分配接入报表学员详情",
      emptyText: "暂无数据",
      loadingText: "加载中...",
      tableLoading: false,
      tableData: [],
      // 从URL参数获取的查询条件
      queryParams: {},
      gradeList: [], // 年级列表
      // 来源渠道
      sourseList: [],
      // 老师列表
      adminList: [],
      businessList: [],
      educationalList: [],
      operationList: [],
      marketingList: [],
      // 备注弹窗
      dialogVisibleRemarks: false,
      remarksList: [],
      remarksTitle: "",
             // 跟踪记录弹窗
       dialogVisibleTrack: false,
       TrackTitle: "",
       studentId: null,
       // 课程弹窗
       dialogVisibleCourse: false,
       payCourseList: [],
       CourseTitle: '',
       // 学生详情弹框
       dialogVisibleDetail: false,
       isFullscreen: false,
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          align: "center",
          width: "55",
          fixed: "left",
        },
        {
          label: "学员姓名",
          prop: "studentName",
          width: "180",
          align: "left",
          inputSearch: true,
          fixed: "left",
          custom: true,
        },
        {
          label: "手机号",
          prop: "telNumber",
          width: "160",
          align: "center",
          inputSearch: true,
          noSetText: "未设置",
          noTooltip: true,
        },
        // {
        //   label: "QQ号",
        //   prop: "qqNumber",
        //   width: "160",
        //   align: "center",
        //   inputSearch: true,
        //   noSetText: "未设置",
        //   noTooltip: true,
        // },
         {
           label: "微信ID",
           prop: "wechatId",
           width: "140",
           align: "center",
           inputSearch: true,
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "缴费总金额",
           prop: "payMoney",
           align: "center",
           width: "160",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "登记时间",
           prop: "createTime",
           align: "center",
           width: "160",
           noSetText: "未设置",
           custom: true,
         },
         {
           label: "报名课程",
           prop: "payCourses",
           align: "center",
           width: "160",
           noSetText: "未设置",
           custom: true,
         },
        {
          label: "学员当前状态",
          prop: "stateStr",
          align: "center",
          width: "160",
          noSetText: "未设置",
          selectSearch: true,
          stateStr: null,
          selectOptions: [],
          noTooltip: true,
          custom: true,
        },
        {
          label: "报名意向",
          prop: "studentIntentStr",
          align: "center",
          width: "170",
          selectSearch: true,
          selectOptions: [],
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "首分老师",
          prop: "firstBusinessName",
          align: "center",
          width: "160",
          selectSearch: true,
          selectOptions: [],
          noSetText: "未设置",
          noTooltip: true,
          remoteMethod: true,
        },
        {
          label: "所在年级",
          prop: "gradeStr",
          align: "center",
          width: "160",
          noSetText: "未设置",
          selectSearch: true,
          gradeStr: null,
          selectOptions: [],
        },
        {
          label: "所属业务老师",
          prop: "businessName",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          businessName: null,
          selectOptions: "",
          remoteMethod: true,
        },
        {
          label: "所属教务老师",
          prop: "handoverName",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          handoverName: null,
          selectOptions: "",
          remoteMethod: true,
        },
        {
          label: "网络营销老师",
          prop: "marketingName",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          marketingName: null,
          selectOptions: "",
          remoteMethod: true,
        },
                 {
           label: "用户运营老师",
           prop: "operationName",
           align: "center",
           width: "160",
           noSetText: "未设置",
           noTooltip: true,
           selectSearch: true,
           operationName: null,
           selectOptions: "",
          remoteMethod: true,
         },
        {
          label: "来源渠道",
          prop: "sourceStr",
          align: "left",
          width: "260",
          noSetText: "未设置",
          noTooltip: true,
          cascader: true,
          sourceStr: null,
          multiple: true,
          selectOptions: [],
        },
         {
           label: "专科院校",
           prop: "graduatedSchool",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "专科专业",
           prop: "graduatedMajor",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "英语基础",
           prop: "basicEnglishStr",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "报名时间",
           prop: "signUpTime",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "报考院校",
           prop: "applySchool",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "报考专业",
           prop: "applyMajor",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "报考院校备选",
           prop: "applySchoolTo",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "报考专业备选",
           prop: "applyMajorTo",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "录取状态",
           prop: "admissionStr",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "录取院校",
           prop: "admissionSchool",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
         {
           label: "录取专业",
           prop: "admissionMajor",
           align: "center",
           width: "200",
           noSetText: "未设置",
           noTooltip: true,
         },
        {
          label: "创建时间",
          prop: "createTime",
          width: "160",
          align: "center",
          noSetText: "未设置",
          noTooltip: true,
        },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  async created() {
    this.getQueryParams();
    this.getGradeList(); // 获取年级列表
    this.getStudentCategoryList(); // 获取来源渠道
    this.getData();
    this.studentStates()
    this.getType()
  },
  mounted() {
    this.getTeacherList();
  },
  computed: {
    tableMaxHeight() {
      const h = document.documentElement.clientHeight || document.body.clientHeight;
      if (h > 768) {
        return h - 160;
      } else {
        return h + 100;
      }
    },
  },
  methods: {
    async searchRemote(val){
      let businessRoleId = this.$store.state.allConfig.businessRoleId
      let educationalRoleId = this.$store.state.allConfig.educationalRoleId
      let operationRoleId = this.$store.state.allConfig.operationRoleId
      let marketingRoleId = this.$store.state.allConfig.marketingRoleId
      let data = {
        ids: [],
        keyWord: val.value,
        pageSize: 50,
        adminTypeIds: []
      };
      if(val.prop === 'businessName'){
        data.adminTypeIds = [businessRoleId]
      }else if(val.prop === 'firstBusinessName'){
        data.adminTypeIds = [businessRoleId]
      }else if(val.prop === 'handoverName'){
        data.adminTypeIds = [educationalRoleId]
      }else if(val.prop === 'operationName'){
        data.adminTypeIds = [operationRoleId]
      }else if(val.prop === 'marketingName'){
        data.adminTypeIds = [marketingRoleId]
      }
      let res = await getAdminList(data);
        for (let item of this.headerData) {
          if (item.prop === val.prop) {
            item.selectOptions = res.result;
            item.selectOptions.unshift({ id: 0, name: "全部" });
          }
        }
    },
    async getType() {
        const res = await GetCatetListByType(3);
        if (res.code == 1) {
          this.typeList = res.result;
          this.typeList.unshift({
              key: '',
              value: '报名意向(全部)'
          })
          this.headerData.map((item) => {
            if (item.prop == "studentIntentStr") {
              item.selectOptions = this.typeList;
            }
          });
        }
    },
    async studentStates(){
      // 学员当前状态接口
      const result1 = await GetBusinessStudentsSelectListData();
      if (result1.code == 0) {
        return false;
      }
      console.log(result1,'result1result1')
      if (result1 && result1.studentStateList.length > 0) {
        this.headerData.map((item) => {
          if (item.prop == "stateStr") {
            result1.studentStateList.unshift({
              key: 0,
              value: "全部",
            });
            item.selectOptions = result1.studentStateList;
          }
        });
      }
    },
    // 格式化学生状态属性名
    converInfo(obj) {
      let aaa = JSON.stringify(obj).replace(/state/g, "studentState");
      return JSON.parse(aaa.replace(/stateStr/g, "studentStateStr"));
    },
    // 获取URL查询参数
    getQueryParams() {
       // 获取URL参数，同时兼容hash路由和普通URL
       let queryString = ''
      if (window.location.hash.includes('?')) {
        // hash路由形式
        queryString = window.location.hash.split('?')[1]
      } else {
        // 普通URL形式
        queryString = window.location.search.slice(1)
      }
      let urlParams = new URLSearchParams(queryString)
      console.log(urlParams.get('allocationState'),'urlParamsurlParams')
      this.queryParams = {
        BusinessId: urlParams.get("BusinessId"),
        allocationState: urlParams.get("allocationState"),
        Type: urlParams.get("Type"),
        Grade: urlParams.get("Grade"),
        BeginTime: urlParams.get("BeginTime"),
        EndTime: urlParams.get("EndTime"),
        Source: urlParams.getAll("Source"), // 使用getAll获取所有Source参数值组成数组
        tableName: urlParams.get("tableName"),
        reportType: urlParams.get("reportType"),
      };

      if (this.queryParams.tableName) {
        this.tableName = this.queryParams.tableName;
      }
    },

    // 获取数据
    async getData() {
      if (this.tableLoading) return;

      this.tableLoading = true;
      try {
        const params = {
          ...this.queryParams,
          PageIndex: this.pagination.currentPage,
          PageSize: this.pagination.pageSize,
        };

        const res = await GetReportStudentList(params);

        if (res.code === 1) {
          // 对数据进行去重处理
          const rawData = res.result.data || [];
          const uniqueData = this.removeDuplicates(rawData);
          
          this.tableData = uniqueData;
          this.pagination.total = res.result.totalRecords || 0;
        } else {
          this.$message.error(res.message || "获取数据失败");
        }
      } catch (error) {
        this.$message.error("获取数据失败");
      } finally {
        this.tableLoading = false;
      }
    },
    // 添加去重方法
    removeDuplicates(data) {
      const seen = new Set();
      return data.filter(item => {
        const duplicate = seen.has(item.id);
        seen.add(item.id);
        return !duplicate;
      });
    },
    // 表格搜索
    tableSearch(val) {
      if (!isNull(val.prop) && val.prop == "studentName") {
        this.queryParams.Name = val.value;
      }
      if (!isNull(val.prop) && val.prop == "telNumber") {
        this.queryParams.TelNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "qqNumber") {
        this.queryParams.QqNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "wechatId") {
        this.queryParams.WechatId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "gradeStr") {
        this.queryParams.Grade = val.value;
      }
      if (!isNull(val.prop) && val.prop == "sourceStr") {
        this.queryParams.Source = val.value;
      }
      if (!isNull(val.prop) && val.prop == "businessName") {
        this.queryParams.BusinessId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "firstBusinessName") {
        this.queryParams.FirstBusinessId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "stateStr") {
        this.queryParams.State = val.value;
      }
      if (!isNull(val.prop) && val.prop == "handoverName") {
        this.queryParams.HandoverId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "operationName") {
        this.queryParams.OperationId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "marketingName") {
        this.queryParams.MarketingId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "studentIntentStr") {
        this.queryParams.StudentIntent = val.value;
      }

      this.queryParams.PageIndex = 1;
      this.pagination.currentPage = 1;
      this.getData();
    },

    // 分页改变
    changePagination(pagination) {
      this.pagination.currentPage = pagination.currentPage;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },

    // 获取年级列表
    async getGradeList() {
      const result = await GetCatetListByType(4);
      if (result.code == 1) {
        let gradeList = [];
        if (result.result && result.result.length) {
          result.result.forEach((item) => {
            gradeList.push({
              key: item.id,
              value: item.name,
            });
          });
          this.gradeList = gradeList;
          // 更新表头配置
          this.headerData.forEach((item) => {
            if (item.prop === "gradeStr") {
              item.selectOptions = this.gradeList;
              item.selectOptions.unshift({ key: "0", value: "所在年级(全部)" });
            }
          });
        }
      }
    },

    // 获取老师列表
    async getTeacherList() {
      // 等配置信息接口返回后再获取老师列表
      let resolveConfig;
      const promise = new Promise((resolve) => {
        resolveConfig = resolve;
      });
      const interval = setInterval(() => {
        if (this.$store.state.allConfig) {
          clearInterval(interval);
          resolveConfig();
        }
      }, 100);
      await promise;
      var businessRoleId = this.$store.state.allConfig.businessRoleId;
      var educationalRoleId = this.$store.state.allConfig.educationalRoleId;
      var operationRoleId = this.$store.state.allConfig.operationRoleId;
      var marketingRoleId = this.$store.state.allConfig.marketingRoleId;
      let data = {
        ids: [0],
        keyWord: "",
        pageSize: 500,
        adminTypeIds: [
          educationalRoleId,
          businessRoleId,
          operationRoleId,
          marketingRoleId,
        ],
      };

      const res = await getAdminList(data);
      if (res && res.code && res.code == 0) {
        this.$alert(res.message);
        return false;
      } else {
        this.adminList = res.result;
      }
      if (!isNull(this.adminList)) {
        res.result.forEach((item) => {
          // 确保item.id和item.name存在且有效
          if (item && item.id !== undefined && item.id !== null && item.name && item.rolesId !== undefined) {
            if (item.rolesId == businessRoleId) {
              this.businessList.push({ key: item.id, value: item.name });
            } else if (item.rolesId == educationalRoleId) {
              this.educationalList.push({ key: item.id, value: item.name });
            } else if (item.rolesId == operationRoleId) {
              this.operationList.push({ key: item.id, value: item.name });
            } else if (item.rolesId == marketingRoleId) {
              this.marketingList.push({ key: item.id, value: item.name });
            }
          }
        });
        for (let item of this.headerData) {
          if (item.prop === "businessName") {
            item.selectOptions = this.businessList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
          if (item.prop === "firstBusinessName") {
            item.selectOptions = this.businessList;
          }
          if (item.prop === "handoverName") {
            item.selectOptions = this.educationalList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
          if (item.prop === "operationName") {
            item.selectOptions = this.operationList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
          if (item.prop === "marketingName") {
            item.selectOptions = this.marketingList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
        }
      }
    },

    // 获取来源渠道
    async getStudentCategoryList() {
      let sourseList = [];

      const result = await GetCatetListByType(2);
      if (result.code == 1) {
        sourseList = result.result;
        // 来源渠道
        let sourseList1 = {},
          sourseList0 = [],
          sourseList2 = {},
          sourseList3 = {};
        if (sourseList && sourseList.length) {
          sourseList.map((item) => {
            sourseList1.label = item.name;
            sourseList1.value = item.id;
            if (item.childModel && item.childModel.length > 0) {
              sourseList1.children = [];
              item.childModel.map((item1) => {
                sourseList2.label = item1.name;
                sourseList2.value = item1.id;
                if (item1.childModel && item1.childModel.length > 0) {
                  sourseList2.children = [];
                  item1.childModel.map((item2) => {
                    sourseList3.label = item2.name;
                    sourseList3.value = item2.id;
                    sourseList2.children.push(sourseList3);
                    sourseList3 = {};
                  });
                }
                sourseList1.children.push(sourseList2);
                sourseList2 = {};
              });
            }
            sourseList0.push(sourseList1);
            sourseList1 = {};
          });
          this.sourseList.push(...sourseList0);
        }
      }
      this.headerData.map((item) => {
        if (item.prop == "sourceStr") {
          item.selectOptions = this.sourseList;
        }
      });
    },

    // 点击弹框
    openDialog(row) {
      this.studentId = row.id + 0;
      this.dialogVisibleDetail = true;
    },

           // 处理备注和课程
       handleScopeCourse(row, state) {
         // 查看备注信息
         if (state == "remarks") {
           this.remarksList = row.remarks;
           this.remarksTitle = `学员[${
             row.studentName ? row.studentName : "暂未设置姓名"
           }]的备注信息`;
           this.dialogVisibleRemarks = true;
         }
         // 查看购买课程
         if (state == "PayCourse") {
           this.payCourseList = row.payCourses;
           this.CourseTitle = `学员[${row.studentName ? row.studentName : "暂未设置姓名"}]购买的课程`;
           this.dialogVisibleCourse = true;
         }
       },

    // 点击跟踪标签
    handleScopeTrack(row) {
      this.studentId = row.id;
      this.TrackTitle = `[${
        row.studentName ? row.studentName : "暂未设置姓名"
      }]学员的跟踪记录`;
      this.dialogVisibleTrack = true;
    },

           // 关闭跟踪记录弹窗
       closeDialog() {
         this.dialogVisibleTrack = false;
       },

       // 是否全屏
       isfullscreen(val) {
         this.isFullscreen = val;
       },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
  padding-right: 10px !important;
}

.table_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ececec;
  text-align: center;
  font-weight: bold;
  /* padding: 5px 0; */
  margin-top: 10px;
}

::v-deep .el-table {
  margin-top: 0 !important;
}

.seat {
  height: 30px;
}

::v-deep .el-input,
.el-textarea {
  font-size: 14px;
  /* width: 60%; */
}

::v-deep .el-dialog {
  top: 30vh;
}

.hand {
  cursor: pointer;
}

.blue {
  color: #409eff;
}

.gray {
  color: #909399;
}

.dialog_div1 {
  height: 400px;
  overflow: auto;
}

.dialog_div2 {
  height: 420px;
  overflow: auto;
}

.abow_dialog3 /deep/ .el-tabs__content {
  overflow: auto;
}
</style>
